import { Checkbox, FormControl } from "@caspeco/casper-ui-library";
import { useBookingActionsContext, useBookingStateContext } from "hooks/use-booking-state";
import React from "react";
import { useTranslation } from "react-i18next";
const NewsletterField = () => {
    const { t } = useTranslation();
    const { setContact } = useBookingActionsContext();
    const { contact } = useBookingStateContext();

    const handleNewsletterToggle = (event: React.ChangeEvent<HTMLInputElement>) =>
        setContact?.({ newsletter: event.target.checked });
    return (
        <FormControl>
            <Checkbox
                isChecked={contact?.newsletter}
                onChange={handleNewsletterToggle}
                color="primary"
            >
                {t("contact.newsletterSignup")}
            </Checkbox>
        </FormControl>
    );
};

export default NewsletterField;
